<template>
  <div style="height: inherit">
    <conciliacao-faturamento-guias-header />
    <conciliacao-faturamento-guias-status-bar class="mb-2" />
    <v-progress-linear v-if="loading" indeterminate />
    <div v-else style="overflow-y: auto; height: calc(100% - 96px - 8px)">
      <template v-if="countGuias > 0">
        <conciliacao-faturamento-guia-card
          v-for="guia in guias"
          :key="guia.id"
          :faturamento-guia="guia"
          :isUsuarioTradimus="isUsuarioTradimus"
          @click:card="handleCardClick"
          @click:checkbox="handleCheckboxClick"
          @click:more="event => handleMoreClick(event, guia)"
          class="mb-2"
        />
      </template>
    </div>

    <v-menu
      v-model="guiaMenuOpened"
      :activator="menuAnchor"
    >
      <v-list>
        <v-list-item
          v-for="item in menuItems"
          :key="item.title"
          :disabled="item.disabled"
          @click="() => item.action()"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ConciliacaoFaturamentoGuiaCard from './ConciliacaoFaturamentoGuiaCard.vue'
import ConciliacaoFaturamentoGuiasHeader from './ConciliacaoFaturamentoGuiasHeader.vue'
import ConciliacaoFaturamentoGuiasStatusBar from './ConciliacaoFaturamentoGuiasStatusBar.vue'
import { conciliacaoClient, sessionStorageClient } from '../../../libs'

export default {
  components: {
    ConciliacaoFaturamentoGuiaCard,
    ConciliacaoFaturamentoGuiasHeader,
    ConciliacaoFaturamentoGuiasStatusBar
  },
  data () {
    return {
      clickedGuia: undefined,
      guiaMenuOpened: false,
      menuAnchor: null
    }
  },
  computed: {
    ...mapState('conciliacao', ['pagamentoGuiaId', 'faturamentoGuias', 'showFaturamentoItens']),
    guias () {
      return this.faturamentoGuias.result?.data
    },
    loading () {
      return this.faturamentoGuias.loading
    },
    countGuias () {
      return this.guias?.length
    },
    isClickedGuiaAssociada () {
      return this.$store.getters['conciliacao/isFaturamentoGuiaAssociada'](this.clickedGuia?.id)
    },
    menuItems () {
      return [
        { title: 'Associar guia', action: this.handleAssociarGuia, disabled: this.isClickedGuiaAssociada },
        { title: 'Desassociar guia', action: this.handleDesassociarGuia, disabled: !this.isClickedGuiaAssociada }
      ]
    },
    isUsuarioTradimus () {
      const usuarioTradimus = sessionStorageClient.getItem('userData')?.['UsuarioTradimus']
      return usuarioTradimus
    }
  },
  methods: {
    handleCardClick (faturamentoGuia) {
      this.$store.dispatch('conciliacao/openFaturamentoGuia', faturamentoGuia)
    },
    handleCheckboxClick (faturamentoGuia, currentChecked) {
      if (currentChecked) {
        this.$store.dispatch('conciliacao/deselectFaturamentoGuia', faturamentoGuia)
      } else {
        this.$store.dispatch('conciliacao/selectFaturamentoGuia', faturamentoGuia)
      }
    },
    handleMoreClick (event, faturamentoGuia) {
      this.guiaMenuOpened = true
      this.menuAnchor = event.target
      this.clickedGuia = faturamentoGuia
    },
    async handleAssociarGuia () {
      if (this.clickedGuia) {
        const data = [{
          pagamentoGuiaId: this.pagamentoGuiaId,
          faturamentoGuiaId: this.clickedGuia.id
        }]

        try {
          await conciliacaoClient.conciliacaoGuia.createConciliacaoGuias({ data })
          this.$store.dispatch('conciliacao/conciliacaoGuiaCreated')
        } catch (error) {
          const modalParams = {
            type: 'error',
            title: 'Erro ao associar guias',
            btConfirm: {
              name: 'Ok',
              show: true,
              color: 'primary'
            }
          }

          this.$store.commit('confirmMessage/showConfirmMessage', modalParams)
        }
      }
    },
    async handleDesassociarGuia () {
      if (this.clickedGuia) {
        const data = [{
          pagamentoGuiaId: this.pagamentoGuiaId,
          faturamentoGuiaId: this.clickedGuia.id
        }]

        try {
          await conciliacaoClient.conciliacaoGuia.deleteConciliacaoGuias({ data })
          this.$store.dispatch('conciliacao/conciliacaoGuiaDeleted')
        } catch (error) {
          const modalParams = {
            type: 'error',
            title: 'Erro ao desassociar guias',
            btConfirm: {
              name: 'Ok',
              show: true,
              color: 'primary'
            }
          }

          this.$store.commit('confirmMessage/showConfirmMessage', modalParams)
        }
      }
    }
  }
}
</script>
